import { SelectedScreenshare } from 'features/screenshare/types';
import {
  selectSelectedScreenshare,
  selectedScreenshareClosed,
  showAllScreensChanged,
} from 'features/screenshare/screenshareSlice';
import { subscribeToScreenshareSaga } from 'features/screenshare/sagas/subscribeToScreenshareSaga';
import { unsubscribeFromScreenshareSaga } from 'features/screenshare/sagas/unsubscribeFromScreenshareSaga';
import { UserId } from 'features/users/types';
import { selectLocalUserId } from 'features/users/usersSlice';
import { call, select, put } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';
import { selectScreenshareStreams } from 'features/layout/features/order/orderSlice';
import { SourceDetails } from 'features/layout/types';
import { FeedId } from 'features/streaming/types';

export function* onShowAllScreensChangedSaga(action: ReturnType<typeof showAllScreensChanged>) {
  const showAllScreens: boolean = action.payload;
  const localUserId: UserId = yield select(selectLocalUserId);
  const selectedScreenshare: SelectedScreenshare | null = yield select(selectSelectedScreenshare);
  const screenshares: SourceDetails[] = yield select(selectScreenshareStreams);

  if (showAllScreens && selectedScreenshare) {
    yield put(selectedScreenshareClosed());
  }

  const remoteScreenshares = screenshares.filter(
    (screenshare) => screenshare.userId !== localUserId && screenshare.feedId
  ) as (SourceDetails & { feedId: FeedId })[];

  for (const screenshare of remoteScreenshares) {
    if (showAllScreens) {
      const availableStreams = RTCClient.receivingFeed.availableScreenshares[screenshare.feedId];
      yield call(
        subscribeToScreenshareSaga,
        screenshare.userId,
        screenshare.feedId,
        availableStreams,
        {
          videoOnly: true,
        }
      );
    } else if (selectedScreenshare?.feedId !== screenshare.feedId) {
      yield call(unsubscribeFromScreenshareSaga, {
        userId: screenshare.userId,
        feedId: screenshare.feedId,
      });
    }
  }

  yield call(RTCClient.receivingFeed.updateScreenshareSimulcastConfig);
}
